import request from '../utils/request'

/**
 * 支付宝沙箱支付
 * @param orderNo
 * @param returnUrl
 * @returns {Promise}
 */
// export function pay(orderNo) {
//   return request.get('/alipay/pay/'+orderNo)
// }

/**
 * 支付宝沙箱退款
 * tradeNo 订单号
 * refundAmount 退款金额
 */
export function refund(tradeNo,refundAmount) {
  return request.get('/alipay/refund',tradeNo,refundAmount)
}
